import { useState } from 'react'

interface UseLocalEditorState {
  /** Editor content as HTML. Was a draft-js EditorState before the TipTap migration. */
  html: string
  setHtml: (html: string) => void
  toolbarHidden: boolean
  setToolbarHidden: (v: boolean) => void
}

export const useLocalEditorState = (initValue?: string): UseLocalEditorState => {
  const [html, setHtml] = useState<string>(initValue || '')
  const [toolbarHidden, setToolbarHidden] = useState(true)

  // Paste filtering used to live here (`onPaste` -> draftjs-filters). It is no
  // longer needed: the TipTap schema only allows bold, italic and lists, so
  // ProseMirror strips everything else while parsing pasted HTML.
  return {
    html,
    setHtml,
    toolbarHidden,
    setToolbarHidden,
  }
}

export default useLocalEditorState
